import _toConsumableArray from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/get.js";
import _getPrototypeOf from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import ApplicationResource from './ApplicationResource';
import asPagedContentSchema from './utils/asPagedContent';

var ApplicationPaginatedResource = /*#__PURE__*/function (_ApplicationResource) {
  _inherits(ApplicationPaginatedResource, _ApplicationResource);

  var _super = _createSuper(ApplicationPaginatedResource);

  function ApplicationPaginatedResource() {
    _classCallCheck(this, ApplicationPaginatedResource);

    return _super.apply(this, arguments);
  }

  _createClass(ApplicationPaginatedResource, null, [{
    key: "list",
    value: function list() {
      return _get(_getPrototypeOf(ApplicationPaginatedResource), "list", this).call(this).extend({
        schema: asPagedContentSchema(this)
      });
    }
  }, {
    key: "appendList",
    value: function appendList(newResults, existingResults) {
      var _a; // In case there are duplicates, Set will eliminate them.


      var set = new Set([].concat(_toConsumableArray((_a = existingResults === null || existingResults === void 0 ? void 0 : existingResults.content) !== null && _a !== void 0 ? _a : []), _toConsumableArray(newResults.content)));
      return Object.assign(Object.assign({}, newResults), {
        content: _toConsumableArray(set.values())
      });
    }
    /**
     * @deprecated This method was replaced by list and will be removed in another release
     */

  }, {
    key: "listShape",
    value: function listShape() {
      var readShape = _get(_getPrototypeOf(ApplicationPaginatedResource), "listShape", this).call(this);

      return Object.assign(Object.assign({}, readShape), {
        schema: asPagedContentSchema(this),
        options: Object.assign(Object.assign({}, readShape.options), {
          invalidIfStale: true
        })
      });
    }
  }]);

  return ApplicationPaginatedResource;
}(ApplicationResource);

export { ApplicationPaginatedResource as default };